export { default } from './TypographyWithTooltip';
